module.exports = __webpack_public_path__ + "img/Mastercard-Logo.1ff5d4fa.png";